import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AdminRoutingModule } from './admin-routing.module';
import { AdminComponent } from './admin.component';
import { CreateUserComponent } from './create-user/create-user.component';
import { EditUserComponent } from './edit-user/edit-user.component';
import { UserFormComponent } from './shared/user-form/user-form.component';
import { CompanyContactsComponent } from './company-contacts/company-contacts.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { AdminMainComponent } from './admin-main/admin-main.component';
import { MatCheckboxModule, MatInputModule, MatDialogModule, MatIconModule } from '@angular/material';
import { FederatedHelpDialogComponent } from './shared/federated-help-dialog/federated-help-dialog.component';
import { CompanyDropdownComponent } from './company-contacts/company-dropdown/company-dropdown.component';
import { LockUserHelpDialogComponent } from './shared/lock-user-help-dialog/lock-user-help-dialog.component';
import { CompareUserDialogComponent } from './shared/compare-user-dialog/compare-user-dialog.component';

@NgModule({
  declarations: [
    AdminComponent,
    AdminMainComponent,
    CreateUserComponent,
    EditUserComponent,
    UserFormComponent,
    CompanyContactsComponent,
    FederatedHelpDialogComponent,
    CompanyDropdownComponent,
    LockUserHelpDialogComponent,
    CompareUserDialogComponent
  ],
  imports: [
    CommonModule,
    MatInputModule,
    MatCheckboxModule,
    MatDialogModule,
    AdminRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    FlexLayoutModule,
    MatIconModule
  ],
  entryComponents: [
    FederatedHelpDialogComponent,
    LockUserHelpDialogComponent,
    CompareUserDialogComponent
  ]
})
export class AdminModule { }
